import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetPromoCodeQuery } from '../../../api/queries/getPromoCode';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import PromoCodeDetailsInnerPage from './PromoCodeDetailsInnerPage';

const PromoCodeDetailsPage = () => {
    const { promoCodeId } = useParams<{ promoCodeId: string }>();

    const { data, loading } = useGetPromoCodeQuery({
        fetchPolicy: 'network-only',
        variables: { id: promoCodeId },
    });

    const promoCode = data?.promoCode;

    if (!promoCode && loading) {
        return <LoadingElement />;
    }

    if (!promoCode) {
        return <NotFoundResult />;
    }

    return <PromoCodeDetailsInnerPage promoCode={promoCode} />;
};

export default PromoCodeDetailsPage;
